import * as global from '../../constants/global';

export const getCurrentCoordinates = () => {
    return new Promise((resolve) => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({ latitude: position?.coords?.latitude, longitude: position?.coords?.longitude });
            }, () => {
                resolve({ latitude: '', longitude: '' });
            });
        } else {
            resolve({ latitude: '', longitude: '' });
        }
    });
};

// Nominatim's usage policy caps public API usage at 1 request/second - this queue
// serializes every fallback call app-wide so concurrent lookups (e.g. one per row in
// a scan/transfer history table) never fire in parallel and trip a 429.
const NOMINATIM_MIN_INTERVAL_MS = 1100;
let nominatimQueue = Promise.resolve();

const queueNominatimLookup = (latitude, longitude) => {
    const run = nominatimQueue.then(() =>
        fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`).then((response) => response.json())
    );
    nominatimQueue = run.catch(() => null).then(() => new Promise((resolve) => setTimeout(resolve, NOMINATIM_MIN_INTERVAL_MS)));
    return run;
};

const addressCache = new Map();

export const getAddressFromLatLng = async (latitude, longitude) => {
    const cacheKey = `${latitude},${longitude}`;
    if (addressCache.has(cacheKey)) {
        return addressCache.get(cacheKey);
    }
    let address = `${latitude}, ${longitude}`;
    try {
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${global.GOOGLE_MAPS_API_KEY}`);
        const data = await response.json();
        if (data?.status === 'OK' && data?.results?.[0]?.formatted_address) {
            address = data.results[0].formatted_address;
            addressCache.set(cacheKey, address);
            return address;
        }
    } catch (err) {
        // fall back to keyless reverse geocoding below
    }
    try {
        const data = await queueNominatimLookup(latitude, longitude);
        address = data?.display_name || address;
    } catch (err) {
        // keep the lat/long fallback set above
    }
    addressCache.set(cacheKey, address);
    return address;
};
